import * as React from "react";
import "./Hamburger.scss";
export function Hamburger({ onChange = () => { }, collapsed }) {
    const collapsedClass = collapsed ? "" : "is-active";
    return (React.createElement("button", { className: `hamburger hamburger--minus ${collapsedClass}`, onClick: () => {
            onChange();
        }, type: "button" },
        React.createElement("span", { className: "hamburger-box" },
            React.createElement("span", { className: "hamburger-inner" }))));
}
//# sourceMappingURL=Hamburger.js.map